<template>
  <router-view/>
</template>
<script>
import globalMixin from './mixin/globalMixin'
export default {
  mixins: [globalMixin]
}
</script>